module.exports = __webpack_public_path__ + "img/item22.fceab9c5.png";